/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// @mui material components
import Icon from '@mui/material/Icon';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// Material Dashboard 2 PRO React components
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

function PosStay({ setBlockScan, sizeButton, buttonLoading }) {
  const [modalOpen, setModalOpen] = useState(false);
  const btnRef = useRef(null);

  const close = () => {
    setBlockScan(false);
    setModalOpen(false);
  };

  const renderOpen = () => {
    return (
      <Dialog open={modalOpen} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          พักเครื่อง
          <IconButton
            aria-label='close'
            onClick={close}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <MDBox p={2} textAlign='center'>
            <MDTypography variant='h1' color='error'>
              <Icon>av_timer</Icon> กำลังพัก...
            </MDTypography>
          </MDBox>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <MDBox>
      <Tooltip title='Standby'>
        <MDButton
          variant='contained'
          color='dark'
          size='large'
          fullWidth
          sx={{ fontSize: sizeButton }}
          disabled={buttonLoading}
          onClick={() => {
            setBlockScan(true);
            setModalOpen(true);
          }}
          ref={btnRef}
        >
          <i className='fad fa-desktop' /> &nbsp; พักเครื่อง
        </MDButton>
      </Tooltip>
      {renderOpen()}
    </MDBox>
  );
}

PosStay.propTypes = {
  setBlockScan: PropTypes.func.isRequired,
  sizeButton: PropTypes.number.isRequired,
  buttonLoading: PropTypes.bool.isRequired,
};

export default PosStay;
